import request from '@/axios'

// 房间用电量查询
export function getEnergyList(data={}) {
    return request({
        url: '/room/elec/energy/list',
        method: 'get',
        params: data
    })
}
// 房间用电量导出
export function exportEnergyList(data={}) {
    return request({
        url: '/room/elec/energy/export',
        method: 'get',
        params: data
    })
}

